import { render, staticRenderFns } from "./ReplaceTransaction.vue?vue&type=template&id=42652a92"
import script from "./ReplaceTransaction.vue?vue&type=script&lang=js"
export * from "./ReplaceTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports